module.exports = __webpack_public_path__ + "img/1.cbd5810f.png";